import { NavLink } from 'react-router';
import { LayoutDashboard, Bot, Plus, Lightbulb, Copy } from 'lucide-react';

const tabs = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Home' },
  { to: '/bots', icon: Bot, label: 'Bots' },
  { to: '/strategies/new', icon: Plus, label: 'New', isFab: true },
  { to: '/strategies', icon: Lightbulb, label: 'Strategies' },
  { to: '/copy-trade', icon: Copy, label: 'Copy' },
];

export function MobileNav() {
  return (
    <nav className="flex lg:hidden items-center h-16 bg-bg border-t border-glass-border fixed bottom-0 left-0 right-0 z-40">
      {tabs.map(({ to, icon: Icon, label, isFab }) =>
        isFab ? (
          <NavLink
            key={to}
            to={to}
            className="flex-1 flex flex-col items-center justify-center -mt-5"
          >
            <div className="w-11 h-11 rounded-full bg-gradient-to-br from-orange to-amber flex items-center justify-center shadow-glow">
              <Icon size={20} color="white" />
            </div>
            <span className="text-[9px] font-semibold text-ink-3 mt-0.5">{label}</span>
          </NavLink>
        ) : (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center justify-center gap-0.5 py-1 ${
                isActive ? 'text-orange' : 'text-ink-4'
              }`
            }
          >
            <Icon size={18} />
            <span className="text-[9px] font-semibold">{label}</span>
          </NavLink>
        ),
      )}
    </nav>
  );
}
